export { ChampionSays } from "./ChampionSays"
export type { ChampionSaysProps } from "./ChampionSays"
